<div>
  <form class="k-form k-form-md k-mt-2" [formGroup]="form">
    <kendo-dialog title="Add/Remove Contributors" (close)="close()" [minWidth]="250" [width]="450">
      <strong>Contributors for "{{contributorName}}"</strong>
      <div class="k-mp-2 k-mt-4">
        <kendo-listview [data]="existingContributorsList" [style.padding.px]="10" [style.border-bottom.px]="1"
          itemClass="item-border">
          <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
            <kendo-svg-icon *ngIf="!isReadOnly" [icon]="remove" title="remove" (click)="removeContibutor(dataItem)"></kendo-svg-icon>
            {{ dataItem?.firstName }}, {{dataItem?.lastName}}
          </ng-template>
        </kendo-listview>
      </div>
      <div class="k-mp-2 k-mt-4">
        <div class="example-wrapper">
          <kendo-label text="Add Contributor">
            <kendo-multiselect [data]="contributors" textField="firstName" valueField="lastName"
              [readonly]="isReadOnly"
              [clearButton]="false"
              [ngClass]="{ 'readonly-contributor-multiselect': isReadOnly }"
              formControlName="addContributor">
              <ng-template kendoMultiSelectItemTemplate let-dataItem>
                <span class="template">{{ dataItem.firstName }}</span> {{ dataItem.lastName }}
              </ng-template>
            </kendo-multiselect>
          </kendo-label>
        </div>
      </div>

      <kendo-dialog-actions layout="start">
        <button kendoButton (click)="save()" themeColor="primary" size="medium" rounded="large" [disabled]="isReadOnly">Save</button>
      </kendo-dialog-actions>
    </kendo-dialog>
  </form>
</div>